<template>
  <v-container class="d-flex flex-column ma-2">
    <v-form lazy-validation>
      <v-card flat outlined class="pl-2 pr-2">
        <v-container>
          <v-row align="center">
            <v-col>Lowest documented SpO2</v-col>
            <v-col align="end">
              <v-btn-toggle
                active-class="primary white--text"
                mandatory
                v-model="input1"
              >
                <v-btn color="white black--text" class="flex-fill"
                  >&gt; 92 <span class="grey--text">+0</span></v-btn
                >
                <v-btn color="white black--text" class="flex-fill"
                  >89-92 <span class="grey--text">+2</span></v-btn
                >
                <v-btn color="white black--text" class="flex-fill"
                  >&le; 88 <span class="grey--text">+5</span></v-btn
                >
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-container>
        <hr />

        <v-container>
          <v-row align="center">
            <v-col>Current respiratory rate</v-col>
            <v-col align="end">
              <v-btn-toggle
                active-class="primary white--text"
                mandatory
                v-model="input2"
              >
                <v-btn color="white black--text" class="flex-fill"
                  >&le; 22 <span class="grey--text">+0</span></v-btn
                >
                <v-btn color="white black--text" class="flex-fill"
                  >23-28 <span class="grey--text">+1</span></v-btn
                >
                <v-btn color="white black--text" class="flex-fill"
                  >&gt; 28 <span class="grey--text">+2</span></v-btn
                >
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-container>
        <hr />

        <v-container>
          <v-row align="center">
            <v-col> Current nasal cannula flow rate </v-col>
            <v-col align="end">
              <v-btn-toggle
                active-class="primary white--text"
                mandatory
                v-model="input3"
              >
                <v-btn color="white black--text" class="flex-fill"
                  >0-2 <span class="grey--text">+0</span></v-btn
                >
                <v-btn color="white black--text" class="flex-fill"
                  >3-4 <span class="grey--text">+4</span></v-btn
                >
                <v-btn color="white black--text" class="flex-fill"
                  >5-6 <span class="grey--text">+5</span></v-btn
                >
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-card flat outlined class="pa-4">
        <!--      <v-container class="flex-row">-->
        <!--        <v-btn @click="submit" class="mr-4" color="success">-->
        <!--          Submit-->
        <!--        </v-btn>-->
        <!--        <v-btn @click="reset" class="mr-4" color="error">-->
        <!--          Reset-->
        <!--        </v-btn>-->
        <!--      </v-container>-->
        <v-card flat outlined class="pa-2 font-italic">
          The Quick COVID-19 Severity Index was derived from a dataset of
          hospitalized COVID-19 patients. It predicts critical respiratory
          illness at 24-hours as defined by high oxygen requirements,
          non-invasive ventilation, invasive ventilation, or death. For
          information about study derivation, please see
          <a
            href="https://medrxiv.org/cgi/content/short/2020.05.07.20094573v1"
            target="_blank"
            >our manuscript preprint on medRxiv</a
          >.
        </v-card>
        <v-row>
          <v-col class="pl-6">
            qCSI Score:
            <v-alert
              class="mt-2"
              border="bottom"
              colored-border
              :color="outputColor"
              >{{ this.output }}</v-alert
            >
          </v-col>
          <v-col class="pr-6">
            Risk of critical respiratory illness:
            <v-alert
              class="mt-2"
              border="bottom"
              colored-border
              :color="outputColor"
              >{{ this.outputText }}</v-alert
            >
          </v-col>
        </v-row>
        <v-alert border="bottom" colored-border elevation="2" type="error">
          This model is experimental and is not intended to replace clinical
          judgement. It is only to be used by experienced medical providers.
        </v-alert>
      </v-card>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "BasicModel",
  data() {
    return {
      input1: 0,
      input2: 0,
      input3: 0,
      values1: [0, 2, 5],
      values2: [0, 1, 2],
      values3: [0, 4, 5],
      outcomes: [
        "Low-risk, 4%",
        "Low-intermediate, 30%",
        "High-intermediate, 44%",
        "High risk, 57%"
      ],
      outcomeColors: [
        "green",
        "yellow darken-1",
        "orange darken-1",
        "red darken-1"
      ]
    };
  },
  computed: {
    output: function() {
      return (
        this.values1[this.input1] +
        this.values2[this.input2] +
        this.values3[this.input3]
      );
    },
    outputText: function() {
      return this.outcomes[this.getOutcomeIndex()];
    },
    outputColor: function() {
      return this.outcomeColors[this.getOutcomeIndex()];
    }
  },
  methods: {
    getOutcomeIndex: function() {
      const score = this.output;
      if (score <= 3) {
        return 0;
      }
      if (score <= 6) {
        return 1;
      }
      if (score <= 9) {
        return 2;
      }
      return 3;
    }
    // submit() {
    //   const v1 = parseInt(this.input1 || "0");
    //   const v2 = parseInt(this.input2 || "0");
    //   const v3 = parseInt(this.input3 || "0");
    //
    //   //this.output = v1 + v2 + v3;
    //
    // },
    // reset() {
    //   this.input1 = "";
    //   this.input2 = "";
    //   this.input3 = "";
    //
    //   this.output = "";
    //   window.scrollTo(0, 0);
    // }
  }
};
</script>

<style scoped>
.v-btn-toggle {
  flex-direction: row;
  min-width: 300px;
}
.v-btn-toggle > v-btn {
}
.container {
  max-width: 680px;
}
</style>
<!--0-3: Low-risk, 4%-->
<!--4-6: Low-intermediate, 19%-->
<!--7-9: High-intermediate, 40%-->
<!--10-12: High risk, 70%-->
